import React from 'react';

import { Card, CardTheme } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { smartHomeModerationLabels, smartHomeStatuses } from 'client/locale/ru/draftStatus';
import { DraftStatus } from 'client/model/draft';
import { ModerationPipelineItemState } from 'client/utils/draft-actions';
import * as keyset from 'i18n/DraftControlPanel';
import * as statusesKeyset from 'i18n/DraftsStatuses';

import styles from './SmartHomeModeration.module.scss';

const t = i18n(keyset);
const tStatuses = i18n(statusesKeyset);

interface Props {
    draftStatus: DraftStatus;
    state: ModerationPipelineItemState;
    position: number;
    slaTimingsText?: string;
    showSuccessText?: boolean;
    children?: React.ReactNode;
}

const mapStateToTheme: Record<ModerationPipelineItemState, CardTheme> = {
    completed: 'success',
    current: 'info',
    'not-started': 'normal',
    rejected: 'danger',
};

export const SmartHomeModerationItem: React.FC<Props> = ({
    draftStatus,
    state,
    position,
    children,
    slaTimingsText,
    showSuccessText = true,
}) => {
    return (
        <Card className={styles.smartHomeModerationItem__container} theme={mapStateToTheme[state]}>
            <Card className={styles.smartHomeModerationItem__position} theme={mapStateToTheme[state]} view="filled">
                {position}
            </Card>
            <div>
                <div className={styles.smartHomeModerationItem__title}>{tStatuses(smartHomeStatuses[draftStatus])}</div>
                {showSuccessText && state === 'completed' && (
                    <div className={styles.smartHomeModerationLabel}>
                        {tStatuses(smartHomeModerationLabels[draftStatus])}
                    </div>
                )}
                {state === 'rejected' && (
                    <div className={clx(styles.smartHomeModerationLabel, styles.smartHomeModerationLabel_rejected)}>
                        {t('skill-rejected')}
                    </div>
                )}
                {children}
                {slaTimingsText && <div className={styles.smartHomeModerationLabel}>{slaTimingsText}</div>}
            </div>
        </Card>
    );
};
